import { useState } from 'react'

import { PageTemplateContent, Header2 } from 'app/common/templates-next/page-template'
import { WarehouseStockFilterControls } from 'app/filters/warehouse/stock'
import Sticky from 'app/common/templates-next/sticky'
import { WarehouseStockItemId } from 'app/common/types/id'
import { useWarehouseStock } from 'app/dataProviders/warehouse/stock/hooks'
import { useFilterApplied } from 'app/filters/warehouse/stock/filterStore'

import { WarehouseStockToolbar } from './WarehouseStockToolbar'
import { WarehouseStockPaging, WarehouseStockTable } from './table'
import { WarehouseStockGear, useWarehouseStockSettings } from './gear'

export const WarehouseStock = ({
  title,
  createDishMovementLink,
}: {
  title?: string
  createDishMovementLink: (dishId: WarehouseStockItemId) => string
}) => {
  const { rows } = useWarehouseStockSettings()
  const [search, setSearch] = useState('')
  const [currentPageIndex, setCurrentPageIndex] = useState(0)

  const applied = useFilterApplied()

  const { data, loading, request } = useWarehouseStock({
    params: {
      limit: rows,
      offset: currentPageIndex * rows,
      search,
      buildingId: applied.buildingId,
      orgId: applied.orgId,
    },
  })

  return (
    <>
      <PageTemplateContent animate animateResize>
        <div>
          <WarehouseStockFilterControls />
        </div>
      </PageTemplateContent>

      <PageTemplateContent flex>
        <Header2 skipMargin>{title || 'Остатки'}</Header2>
        <WarehouseStockGear />
      </PageTemplateContent>

      <Sticky>
        {(pagingRef, _, shadow) => (
          <PageTemplateContent reference={pagingRef} shadowBottom={shadow}>
            <WarehouseStockToolbar
              onSearch={setSearch}
              orgId={applied.orgId}
              buildingId={applied.buildingId}
              onRefresh={request}
            />
          </PageTemplateContent>
        )}
      </Sticky>

      <PageTemplateContent skipPadding>
        <WarehouseStockTable
          data={data}
          loading={loading}
          createDishMovementLink={createDishMovementLink}
          onRefresh={request}
        />
      </PageTemplateContent>

      <Sticky stickyBottom>
        {(pagingRef, _, shadow) => (
          <PageTemplateContent reference={pagingRef} shadowTop={shadow}>
            <WarehouseStockPaging
              total={data.total}
              limit={rows}
              currentPage={currentPageIndex + 1}
              currentPageSize={data.items.length}
              handlePage={setCurrentPageIndex}
            />
          </PageTemplateContent>
        )}
      </Sticky>
    </>
  )
}
